import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Link, Stack, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/Iconify';
import { FormProvider, RHFTextField, RHFCheckbox } from '../../../components/hook-form';
import { useDispatch, useSelector } from "react-redux";
import { change_password } from '../../../actions/auth';
import { setToken, fetchToken } from '../../../Auth.js'

const axios = require('axios');
// ----------------------------------------------------------------------

export default function RequestRestorePasswordForm() {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [token, setToken] = useState('');

    const { isLoggedIn } = useSelector(state => state.auth);
    const { message } = useSelector(state => state.message);

    const dispatch = useDispatch();

    const RestorePasswordSchema = Yup.object().shape({
        token: Yup.string(),
        password: Yup.string().required('Password is required').test('len', 'Password must be at least 8 symbols', val => val.toString().length >= 8),
        confirm_password: Yup.string().required('Confirmation password is required').oneOf([Yup.ref('password'), null], 'Passwords must match'),
    });

    const defaultValues = {
        token: '',
        password: '',
        confirm_password: '',
    };

    useEffect(() => {
        setToken(new URLSearchParams(new URL(window.location.href).search).get('token'));
    }, []);

    const methods = useForm({
        resolver: yupResolver(RestorePasswordSchema),
        defaultValues,
    });

    const {
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    const onSubmit = async () => {
        const password = methods.getValues().password
        const confirm_password = methods.getValues().confirm_password
        if (password === '' || confirm_password === '' || password !== confirm_password) {
            return
        } else {

            dispatch(change_password(token, password, confirm_password))
                .then(() => {
                    navigate("/login");
                    // window.location.reload();
                })
                .catch(() => {
                    setLoading(false);
                });
        }
    };



    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={3}>
                <RHFTextField
                    name="password"
                    label="New password"
                    type={showPassword ? 'text' : 'password'}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
                                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                <RHFTextField
                    name="confirm_password"
                    label="Confirm password"
                    type={showPassword ? 'text' : 'password'}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
                                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
                    Change password
                </LoadingButton>
            </Stack>




            {message && (
                <div className="form-group">
                    <div className="alert alert-danger" role="alert">
                        {message}
                    </div>
                </div>
            )}
        </FormProvider>
    );
}
